import { IIBSRequestForm } from '@interfaces/IBSRequest';
import { useMutation } from 'react-query';
import { ibsRequest } from '../IBSRequest';

export function useSubmitIBSRequest() {
  return useMutation(async (requestData: IIBSRequestForm) => {
    const { data: authData } = await ibsRequest.getAccessToken();
    const { data } = await ibsRequest.submitIBSRequest(requestData, authData.access_token);
    return data;
  });
}
